import React, { useState, useEffect } from "react";
import { Grid, Icon, Sidebar } from "semantic-ui-react";

import "../styles/dashboard.css";

import SidebarComponent from "./sidebar";
import PlayerComponent from "./player";

const MOUSEMOVEDEFAULT = 200;
let mouseMoveTimer = MOUSEMOVEDEFAULT;

function Dashboard() {
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [toggleSidebarVisible, setToggleSidebarVisible] = useState(false);
  const [dashboardVideoId, setDashboardVideoId] = useState(null);

  const hideSidebar = () => {
    if (sidebarVisible) {
      setSidebarVisible(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (mouseMoveTimer > 0) {
        setToggleSidebarVisible(true);
        mouseMoveTimer -= 1;
      }
      if (mouseMoveTimer === 0) {
        setToggleSidebarVisible(false);
      }
    }, 10);
    return () => clearInterval(interval);
  }, []);

  return (
    <div onMouseMove={() => (mouseMoveTimer = MOUSEMOVEDEFAULT)}>
      <Sidebar.Pushable>
        <SidebarComponent
          visbility={sidebarVisible}
          selectedVideoIdChange={(selectedVideoId) =>
            setDashboardVideoId(selectedVideoId)
          }
        />
        <Sidebar.Pusher dimmed={sidebarVisible} onClick={hideSidebar}>
          <Grid padded="vertically" columns={1} className="dashboard-grid">
            <Icon
              name="angle left"
              size="huge"
              inverted
              className={`dashboard-sidebar-toggle ${
                toggleSidebarVisible
                  ? "dashboard-sidebar-toggle-fade-in"
                  : "dashboard-sidebar-toggle-fade-out"
              }`}
              onClick={(e) => setSidebarVisible(true)}
            />
            <Grid.Column verticalAlign="middle" textAlign="center">
              <PlayerComponent videoId={dashboardVideoId} />
            </Grid.Column>
          </Grid>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    </div>
  );
}

export default Dashboard;
